module.exports = __webpack_public_path__ + "static/img/report3d_icon.eff4b29d.png";